export const RADIO_OPTIONS = [
    { label: 'all data', value: 1, isDisabled: false },
    { label: 'filtered data', value: 0, isDisabled: false },
];
